import state from './moduloMenusState.js';
import mutations from './moduloMenusMutations.js';
import actions from './moduloMenusActions.js';
import getters from './moduloMenusGetters.js';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
